import * as React from "react";
import * as H from "history";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { StoreContext } from "redux-react-hook";
import TagManager from "react-gtm-module";

import configureStore from "src/core/shared/store";
import { AppSettingsProvider } from "src/core/shared/components/AppSettingsProvider";

import { ErrorBoundary } from "./library/components/ErrorBoundry";

const tagManagerArgs = {
  gtmId: "GTM-5SNC4K6",
  dataLayer: {
    client: process.env.REACT_APP_ENVIRONMENT === "dev" ? "local" : window.location.hostname.split(".mezze.io")[ 0 ],
    events: { sendUserInfo: "userInfo" },
    auth: process.env.REACT_APP_GTM_PREVIEW_AUTH,
    preview: process.env.REACT_APP_GTM_PREVIEW_ENVIRONMENT
  }
};

TagManager.initialize(tagManagerArgs);

const history = H.createBrowserHistory();
const { store, persistor } = configureStore(history);

export const App: React.ReactFCWithChildren = () => {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <StoreContext.Provider value={store}>
          <PersistGate
            loading={null}
            persistor={persistor}
          >
            <AppSettingsProvider history={history} />
          </PersistGate>
        </StoreContext.Provider>
      </Provider>
    </ErrorBoundary>
  );
};
